import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import api from "../../api/axios";

// ✅ NB : l’API /users/add/ attend "global_role" côté backend
function AddUserForm() {
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    global_role: "", // ✅ important: clé backend
  });
  const [roles, setRoles] = useState([]); // ex: [{value:"ED", label:"Executive Director", code:"ED"}]
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        // ✅ on demande seulement les rôles “assignables” par l’utilisateur courant
        const { data } = await api.get("/users/roles/", { params: { scope: "assignable" } });

        // ✅ backend renvoie [{ value, label, code }]
        const formatted = (Array.isArray(data) ? data : []).map((r) => ({
          value: r.value ?? r.code, // ex: "ED"
          label: r.label ?? r.value, // ex: "Executive Director"
          code: r.code ?? r.value, // garde le code si besoin
        }));

        setRoles(formatted);
        setError("");
      } catch (err) {
        console.error("roles load error:", err);
        setError("Failed to load roles.");
      }
    };
    fetchRoles();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.username || !formData.email || !formData.password || !formData.global_role) {
      setError("All fields are required.");
      return;
    }

    try {
      // ✅ on envoie { username, email, password, global_role }
      const response = await api.post("/users/add/", formData);
      if (response.status === 201) {
        setSuccess("User added successfully!");
        setFormData({ username: "", email: "", password: "", global_role: "" });
        setError("");
      } else {
        setError("Failed to add user.");
        setSuccess("");
      }
    } catch (err) {
      console.error("add user error:", err);
      setError(err?.response?.data?.error || "Failed to add user.");
      setSuccess("");
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Add User
                </MDTypography>
              </MDBox>
              <MDBox p={3}>
                <form onSubmit={handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <MDInput
                        label="Username"
                        name="username"
                        fullWidth
                        value={formData.username}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <MDInput
                        label="Email"
                        name="email"
                        type="email"
                        fullWidth
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <MDInput
                        label="Password"
                        name="password"
                        type="password"
                        fullWidth
                        value={formData.password}
                        onChange={handleChange}
                      />
                    </Grid>

                    {/* ✅ Select du rôle : on bind "global_role" */}
                    <Grid item xs={12}>
                      <select
                        name="global_role" // ✅ clé backend
                        onChange={handleChange}
                        value={formData.global_role} // ✅ code “ED|GA|SUP|PD”
                        style={{
                          width: "100%",
                          padding: "10px",
                          borderRadius: "5px",
                          border: "1px solid #ccc",
                        }}
                      >
                        <option value="">Select Role</option>
                        {roles.map((role) => (
                          <option key={role.value} value={role.value}>
                            {role.label}
                          </option>
                        ))}
                      </select>
                    </Grid>

                    <Grid item xs={12}>
                      {error && <p style={{ color: "red" }}>{error}</p>}
                      {success && <p style={{ color: "green" }}>{success}</p>}
                    </Grid>
                    <Grid item xs={12}>
                      <MDButton type="submit" color="info" fullWidth>
                        Add User
                      </MDButton>
                    </Grid>
                  </Grid>
                </form>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AddUserForm;
